module.exports = __webpack_public_path__ + "static/media/from-string.5b52b4f2.bin";